module.exports = __webpack_public_path__ + "static/media/mk.c8fb5218.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/mk.svg
// module id = 189
// module chunks = 0